import OpportunityConfig from "./OpportunityConfig";

export default OpportunityConfig;
